module.exports = __webpack_public_path__ + "img/INNOVATION.5443b4cf.svg";